/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var LeasingFinance;
(function (LeasingFinance) {
    LeasingFinance["Operational"] = "Operational";
    LeasingFinance["Financial"] = "Financial";
    LeasingFinance["Loan"] = "Loan";
    LeasingFinance["Cash"] = "Cash";
})(LeasingFinance || (LeasingFinance = {}));
export function LeasingFinanceFromJSON(json) {
    return LeasingFinanceFromJSONTyped(json, false);
}
export function LeasingFinanceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function LeasingFinanceToJSON(value) {
    return value;
}
